module.exports = "<div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\" ng-click=\"cancel()\">&times;</button><h4 class=\"modal-title\" ng-bind=\"scTitle || scText\"></h4></div><div class=\"modal-body1\"><sc-iframe src=\"scRef\"></sc-iframe></div><div class=\"modal-footer\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/shared/iframe-modal.component.html
// module id = 956
// module chunks = 0